import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Logo from "../../assets/logo1.png";

export function generateFichaCaptacaoPDF({ imovel, cliente, corretor, allAtributos }) {
  const doc = new jsPDF("p", "mm", "a4");
  const pageWidth = doc.internal.pageSize.getWidth();
  const getOrDefault = (v) => (v !== undefined && v !== "" ? v : "-");

  const imovelInfo = imovel?.imovelInfo || {};
  const informacoesComerciais = imovel?.informacoesComerciais || {};
  const selectedItems = imovel?.selectedItems || [];
  const ownerInfo = imovel?.ownerInfo || {};

  const hasImovel = !!imovel; // ✅ identifica se existe imóvel selecionado

  // === TOPO ===
  const logoWidth = 80;
  const logoHeight = 15;
  const logoX = (pageWidth - logoWidth) / 2;
  doc.addImage(Logo, "PNG", logoX, 10, logoWidth, logoHeight);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text("Senna Viannini - CRECI PJ: 9568", pageWidth / 2, 28, { align: "center" });
  doc.text("São João Del Rei - MG", pageWidth / 2, 33, { align: "center" });
  doc.text("(32) 99900-3833 | www.sennaviannini.com.br", pageWidth / 2, 38, { align: "center" });
  doc.setDrawColor(180);
  doc.line(15, 42, pageWidth - 15, 42);

  // === TÍTULO ===
  doc.setFontSize(13);
  doc.setFont("helvetica", "bold");
  doc.text("FICHA DE CAPTAÇÃO DE IMÓVEL", pageWidth / 2, 52, { align: "center" });

  // === DADOS DO CLIENTE ===
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text(`Cliente: ${cliente}`, 15, 65);
  doc.text(`Corretor Responsável: ${corretor?.nome || "-"}`, 15, 72);

  // === DADOS DO IMÓVEL ===
  doc.text(`Código do Imóvel: ${getOrDefault(imovelInfo.codigo)}`, 15, 79);
  doc.text(
    `Localização: ${getOrDefault(imovelInfo.bairro)}, ${getOrDefault(imovelInfo.cidade)}`,
    15,
    86
  );

  // === TIPO DO IMÓVEL ===
  const tiposImovel = [
    "CASA",
    "APARTAMENTO",
    "LOTE",
    "POUSADA",
    "SÍTIO",
    "FAZENDA",
    "TERRENO RURAL",
    "GALPÃO",
    "SALA COMERCIAL",
    "IMÓVEL COMERCIAL",
    "IMÓVEL NA PLANTA",
    "CHALÉ",
    "EM CONSTRUÇÃO",
  ];

  let x = 20;
  let y = 106;
  const colSpacing = 55;
  const rowSpacing = 7;
  const colsPerRow = 3;

  doc.setFont("helvetica", "bold");
  doc.text("Tipo do Imóvel:", 15, y);
  y += 8;

  tiposImovel.forEach((tipo, i) => {
    doc.rect(x, y - 3, 4, 4);
    // ✅ Se há imóvel selecionado, marca automaticamente
    if (hasImovel && tipo === imovelInfo.tipo?.toUpperCase()) {
      doc.text("X", x + 1, y);
    }
    doc.text(tipo, x + 6, y);

    x += colSpacing;
    if ((i + 1) % colsPerRow === 0) {
      x = 20;
      y += rowSpacing;
    }
  });

  // === ÁREAS ===
  y += 10;
  autoTable(doc, {
    startY: y,
    theme: "grid",
    styles: { fontSize: 9, halign: "left" },
    margin: { left: 15, right: 15 },
    body: [
      [
        `ÁREA CONSTRUÍDA: ${getOrDefault(informacoesComerciais.areaConstruida)} m²`,
        `ÁREA DO TERRENO: ${getOrDefault(informacoesComerciais.areaTerreno)} m²`,
        `TESTADA PRINCIPAL: ${getOrDefault(informacoesComerciais.frente)} m`,
      ],
      [
        `LADO DIREITO: ${getOrDefault(informacoesComerciais.lateralDireita)} m`,
        `LADO ESQUERDO: ${getOrDefault(informacoesComerciais.lateralEsquerda)} m`,
        `FUNDOS: ${getOrDefault(informacoesComerciais.fundos)} m`,
      ],
    ],
  });

  let y2 = doc.lastAutoTable.finalY + 10;

  // === CÔMODOS ===
  const comodos = [
    { label: "Quartos:", value: informacoesComerciais.quartos },
    { label: "Suítes:", value: informacoesComerciais.suites },
    { label: "Salas:", value: informacoesComerciais.salas },
    { label: "Cozinhas:", value: informacoesComerciais.cozinha },
    { label: "Banheiros:", value: informacoesComerciais.banheiros },
    { label: "Áreas de serviço:", value: informacoesComerciais.areasServico },
    { label: "Varandas:", value: informacoesComerciais.varanda },
    { label: "Vagas de garagem:", value: informacoesComerciais.vagas },
  ];

  doc.setFontSize(10);
  doc.text("Distribuição de cômodos:", 15, y2);
  y2 += 6;

  comodos.forEach((item) => {
    doc.text(item.label, 15, y2);
    for (let i = 1; i <= 5; i++) {
      doc.rect(60 + (i - 1) * 10, y2 - 4, 4, 4);
      // ✅ Marca somente se há imóvel e o valor corresponde
      if (hasImovel && parseInt(item.value) === i) {
        doc.text("X", 61 + (i - 1) * 10, y2);
      }
      doc.text(String(i), 60 + (i - 1) * 10, y2 + 4);
    }
    y2 += 9;
  });

  // === ATRIBUTOS ===
  doc.addPage();

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("CARACTERÍSTICAS ADICIONAIS", pageWidth / 2, 25, { align: "center" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text("Marque abaixo as características presentes no imóvel:", 15, 38);

  let yAttr = 50;
  const itemsPerColumn = Math.ceil(allAtributos.length / 3);
  const colWidth = 60;
  let colX = 15;
  let itemY = yAttr;

  allAtributos.forEach((item, index) => {
    doc.rect(colX, itemY - 3, 3, 3);
    // ✅ Marca apenas se há imóvel selecionado e o atributo está incluído
    if (hasImovel && selectedItems.includes(item)) {
      doc.text("X", colX + 0.8, itemY);
    }
    doc.setFontSize(9);
    doc.text(item, colX + 5, itemY, { maxWidth: colWidth - 6 });

    itemY += 5;
    if ((index + 1) % itemsPerColumn === 0) {
      colX += colWidth;
      itemY = yAttr;
    }
  });

  // === AUTORIZAÇÃO ===
  doc.addPage();
  const width = doc.internal.pageSize.getWidth();

  doc.setFontSize(12);
  doc.setFont("helvetica", "bold");
  doc.text("AUTORIZAÇÃO DE VENDA / LOCAÇÃO", width / 2, 25, { align: "center" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  let authY = 40;
  doc.text(
    `Proprietário: ${getOrDefault(ownerInfo.nome)} ${getOrDefault(ownerInfo.sobrenome)}`,
    15,
    authY
  );
  doc.text(`CPF: ${getOrDefault(ownerInfo.cpf)}`, 15, (authY += 6));
  doc.text(`Telefone: ${getOrDefault(ownerInfo.telefone)}`, 15, (authY += 6));
  doc.text(
    "O(s) proprietário(s) autoriza(m) a Imobiliária Senna Viannini a promover a venda e/ou locação do imóvel acima descrito, de acordo com as condições informadas.",
    15,
    (authY += 10),
    { maxWidth: 180 }
  );
  doc.text(
    `Valor de venda: R$ ${getOrDefault(informacoesComerciais.valor)}`,
    15,
    (authY += 12)
  );

  // === Assinaturas ===
  const signY = 250;
  doc.line(25, signY, 85, signY);
  doc.text("Proprietário", 40, signY + 6);
  doc.line(120, signY, 180, signY);
  doc.text("Corretor Responsável", 132, signY + 6);

  // === Rodapé ===
  doc.setFontSize(9);
  doc.text(
    `Corretor: ${corretor?.nome || "-"}  |  CRECI: ${corretor?.creci || "-"}`,
    width / 2,
    285,
    { align: "center" }
  );
  doc.text("Senna Viannini Imobiliária - CRECI PJ: 9568", width / 2, 291, { align: "center" });

  doc.save(`Ficha_Captacao_${imovelInfo.codigo || "imovel"}.pdf`);
}
